import { DiscussionVote } from "../../models";

export interface DiscussionVoteListResult {
  votes: DiscussionVote[];
  voteCount: { total: number; currentPage: number };
  pages: { total: number; currentPage: number };
}
